import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTopologyEnrolledCourses } from '@actions/courses';
import useEnroll from '@hooks/useEnroll';
import Dialog from '@comp/Dialog/Dialog';
import { getEnrolledCoursesFeed } from '@selectors/syllabus';
import { staticStrings } from '@constants/index';
import { Spacings } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import PaginatedContainer from './PaginatedContainer';
import PlusCard from './PlusCard';
import { enrollProps } from './syllabusHelper';
import BlockWrapper from './BlockWrapper';

const StyledPlusCard = styled(PlusCard)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const imageBorderRadius = `${Spacings.SPACING_2B} ${Spacings.SPACING_0B} ${Spacings.SPACING_0B} ${Spacings.SPACING_2B}`;

const EnrolledCourses = ({ topic }) => {
  const feedBlock = useSelector((state) =>
    getEnrolledCoursesFeed(state, topic.uid)
  );

  const dispatch = useDispatch();
  const { isUnEnrollModalOpen, toggleEnroll, acceptOnClick, onCloseModal } =
    useEnroll(enrollProps);
  const loadMore = useCallback(() => {
    dispatch(fetchTopologyEnrolledCourses(topic.uid, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topic.uid]);
  const isMobile = useIsMobile();
  const renderBlock = useCallback(
    (courseData, index) => {
      return (
        <StyledPlusCard
          key={courseData.course}
          courseData={courseData}
          toggleEnroll={toggleEnroll}
          index={index}
          imageBorderRadius={imageBorderRadius}
          showProgress
          orientation={isMobile ? 'vertical' : 'horizontal'}
        />
      );
    },
    [isMobile, toggleEnroll]
  );
  if (!feedBlock.results.length) return null;
  return (
    <BlockWrapper>
      <PaginatedContainer
        feedBlock={feedBlock}
        loadMore={loadMore}
        title="My enrolled courses"
        _renderItem={renderBlock}
      />
      <Dialog
        onClose={onCloseModal}
        dialogState={isUnEnrollModalOpen}
        heading="Are you sure you want to unenroll?"
        message={staticStrings.UNENROLL_MESSAGE}
        acceptLabel="Unenroll"
        rejectLabel="Cancel"
        acceptOnClick={acceptOnClick}
        rejectOnClick={onCloseModal}
      />
    </BlockWrapper>
  );
};

EnrolledCourses.propTypes = {
  topic: PropTypes.objectOf(PropTypes.string).isRequired
};

export default EnrolledCourses;
